module.exports = __webpack_public_path__ + "static/img/Jasper-Hay.4eb0a39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jasper-Hay.jpg
// module id = tMcl
// module chunks = 0